import {Component, OnInit, Input} from '@angular/core';
import {ServiceJobDTOModel} from 'src/app/models/service-job-DTO.model';
import {ModalController} from '@ionic/angular';
import {TasksIconsService} from '../../services/workshopServices/tasks-icons.service';

@Component({
    selector: 'app-legacy-job-history-detail',
    templateUrl: './legacy-job-history-detail.page.html',
    styleUrls: ['./legacy-job-history-detail.page.scss'],
})
export class LegacyJobHistoryDetailPage implements OnInit {

    @Input() job: ServiceJobDTOModel;

    constructor(public modalController: ModalController,
                private tasksIcon: TasksIconsService) {
    }

    ngOnInit() {
    }


}
